<template>
  <div class="review-card border-light">
    <div class="is-flex falign-center">
      <router-link :to="{ name: 'UserProfile', params: { uuid: review.author.id } }">
        <avatar class="has-text-weight-bold avatar" backgroundColor="#29357f" color="#fff" :username="review.author.name"/>
      </router-link>
      <div>
        <div class="has-text-weight-bold">
          <router-link :to="{ name: 'UserProfile', params: { uuid: review.author.id } }" class="color-gray box-line-clamp-1">
            {{ review.author.name }}
          </router-link>
        </div>
        <div class="is-italic" :class="{'font-size-9': !isMobile}">{{ review.author.reviewsCount }} {{ pluralize('review', review.author.reviewsCount) }} | Active since {{ review.author.activeSince }}</div>
      </div>
    </div>
    <div>
      <div :class="{'font-size-9': !isMobile}">
        <rating :stars="getIntegerRating"/>
        {{ review.createdOn }}
      </div>
    </div>

    <h2 v-html="review.title" class="has-text-weight-bold box-line-clamp-1"
        :class="{'color-blue-dark': !isMobile, 'margin-top-7': !isMobile, 'margin-bottom-4': !isMobile, 'margin-top-4': isMobile, 'margin-bottom-5': isMobile, 'font-size-12': isMobile}">
    </h2>
    <div class="rc__body" v-html="review.body"></div>
    <a :href="review.reviewLink" class="link--v2" :class="{'font-size-11': isMobile}">
      See more
    </a>
  </div>
</template>
<script>
import Avatar from 'vue-avatar'
import {misc, auth} from '@/mixins'
import {Rating} from '@/components'

export default {
  name: 'BizOtherReviewCard',
  components: {
    Avatar,
    Rating
  },
  mixins: [misc, auth],
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  computed: {
    getIntegerRating () {
      if (Number.isInteger(this.review.rating)) {
        return this.review.rating
      }
      if (typeof this.review.rating === 'string') {
        const parsed = parseInt(this.review.rating);
        return isNaN(parsed) ? 0 : parsed;
      }
      return 0
    }
  },
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";
@import "@/assets/scss/utilities/_misc.scss";

.review-card {
  font-size: 11px;
  height: 244px;
  padding: 14px 15px 0 16px;
  border-radius: 12.5px;

  @include tablet {
    padding: 14px 13px 0 14px;
  }

  @include mobile {
    font-size: 10px;
    height: 218px;
    padding: 9px 9px 0;
  }

  .avatar {
    width: 34px !important;
    height: 34px !important;
    margin-right: 6px;
    font-size: 14px !important;

    @include not-desktop {
      width: 30px !important;
      height: 30px !important;
    }

    @include tablet {
      font-size: 13px !important;
    }

    @include mobile {
      font-size: 12px !important;
    }
  }

  > > > .star-new {
    font-size: 8px;
    display: inline-block;
    margin-left: 35px;
    margin-right: 5px;

    @include tablet {
      margin-right: 0;

      li {
        margin-left: 1px;
      }
    }

    @include mobile {
      margin-left: 0;
      margin-top: 5px;
      font-size: 10px;
    }

    ul {
      width: auto;
    }
  }

  .box-line-clamp-1 {
    @include box-line-clamp(1);
  }

  .rc__body {
    word-break: break-word;
    white-space: pre-wrap;
    margin-bottom: 3px;
    @include box-line-clamp(7);

    @include mobile {
      font-size: 11px;
      margin-bottom: 14px;
      @include line-clamp(5);
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/reviewCards/BizOtherReviewCard.vue